<template>
  <div class="sale-details">
    <div class="d-flex align-items-center justify-content-between mb-6">
      <span class="fs-18 modal-title">
        Detalhes da venda
      </span>
      <button class="btn btn-sm btn-square" @click="$emit('close')">
        <i class="icon-x fs-20 text-secondary" />
      </button>
    </div>

    <div
      v-if="saleProduct"
      class="d-flex justify-content-between align-items-center my-6"
    >
      <div class="d-flex align-items-center">
        <img
          class="product-sm-picture mr-3"
          :src="
            saleProduct.picture ||
              require('@/assets/images/product-example.svg')
          "
          alt="imagem do produto"
        />
        {{ saleProduct.name }}
      </div>
      <div>
        <span :class="getStatusBadge(sale)">
          {{ sale.status | formatStatusName }}
        </span>
      </div>
    </div>

    <b-tabs justified>
      <b-tab title="Dados do cliente" active>
        <div class="row mt-5">
          <div class="col-lg-6">
            <small>Nome do cliente</small>
            <div class="form-control">
              <div class="ellipsis">
                {{ sale.shopper_name }}
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <small>E-mail do cliente</small>
            <div class="form-control">
              <div class="ellipsis">
                {{ sale.shopper_email }}
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <small>Telefone</small>
            <div class="form-control">
              {{ sale.shopper_phone }}
            </div>
          </div>
          <div class="col-lg-6">
            <small>Documento de identificação</small>
            <div class="form-control">
              {{ sale.shopper_document }}
            </div>
          </div>
          <div class="col-lg-6" v-if="sale.instagram">
            <small>Instagram do Cliente</small>
            <div class="form-control">
              {{ sale.instagram }}
            </div>
          </div>
        </div>

        <template v-if="sale.token_subscription">
          <small>Link para troca do cartão</small>
          <div class="input-group mb-6">
            <input
              type="text"
              readonly
              class="form-control m-0"
              :value="sale.token_subscription.link"
            />
            <div class="input-group-append">
              <button
                @click="copyChangeLink"
                class="btn btn-primary btn-sm"
                type="button"
              >
                Copiar
              </button>
            </div>
          </div>
        </template>

        <div class="d-flex flex-column flex-lg-row justify-content-end mt-lg-6">
          <button
            v-if="$permissions.hasPermission('reenviar-notificacoes')"
            class="btn btn-outline-primary mb-6 mb-lg-0"
            :disabled="loadingPost"
            @click="resendPost"
          >
            Reenviar POST
          </button>

          <button
            v-if="$permissions.hasPermission('alterar-e-mail-do-comprador')"
            class="btn btn-outline-primary ml-lg-5"
            @click="changeEmailDialog = true"
          >
            Trocar e-mail
          </button>

          <button
            v-if="showChangeCard"
            class="btn btn-outline-primary mt-6 mt-lg-0 ml-lg-5"
            @click="changeCard"
          >
            <loading :show="loadingCard">
              Trocar cartão
            </loading>
          </button>
        </div>
      </b-tab>

      <b-tab title="Informações da compra">
        <div class="row mt-5">
          <div class="col-lg-12 px-lg-2">
            <small>Oferta</small>
            <div class="form-control">
              {{ sale.offer_name || "Oferta principal" }}
            </div>
          </div>
          <div class="col-lg-6">
            <small>Código da transação</small>
            <div class="form-control">
              <div class="ellipsis">
                {{ code }}
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <small>Status da transação</small>
            <div class="form-control">
              <span :class="getStatusBadge(sale)">
                {{ sale.status | formatStatusName }}
              </span>
            </div>
          </div>
          <div class="col-lg-6">
            <template v-if="$permissions.hasPermission('visualizar-valores')">
              <small>Valor da compra</small>
              <div class="form-control">
                R$ {{ formatMoney(sale.amount) }} ({{
                  getPayMethod(sale.payment_method)
                }})
              </div>
            </template>
          </div>
          <div class="col-lg-6">
            <small>Parcelas</small>
            <div class="form-control">
              {{ sale.installments }}
            </div>
          </div>
          <div class="col-lg-6">
            <small>Data da compra</small>
            <div class="form-control">
              {{ createdAt }}
            </div>
          </div>
          <div class="col-lg-6">
            <small>Data de aprovação</small>
            <div class="form-control">
              {{ paidAt }}
            </div>
          </div>

          <template
            v-if="sale.charge_data.cards && sale.charge_data.cards.length"
          >
            <div class="col-lg-6">
              <small>Mensagem</small>
              <div class="form-control">
                <div class="ellipsis">
                  {{ lastCard.acquirer_message }}
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <small>Últimos 4 dígitos do cartão</small>
              <div class="form-control">
                {{ lastCard.last_four_digits || "-" }}
              </div>
            </div>
          </template>

          <div class="col-lg-6">
            <small>Link do pagamento</small>
            <div class="form-control">
              <div class="ellipsis">
                {{ sale.shopper_offer_link }}
              </div>
              <button class="btn px-2 btn-sm" @click="copyLink">
                <i class="fa-regular fa-copy text-primary" />
              </button>
            </div>
          </div>
          <div class="col-lg-6">
            <small>Origem de checkout (sck)</small>
            <div class="form-control">
              {{ sale.sck }}
            </div>
          </div>
          <div class="col-lg-6">
            <small>Order Bump</small>
            <div class="form-control">
              <span
                :class="`${!!sale.is_order_bump ? 'active' : 'inactive'}-badge`"
              >
                {{ !!sale.is_order_bump ? "Sim" : "Não" }}
              </span>
            </div>
          </div>
          <div class="col-lg-6">
            <small>Upsell</small>
            <div class="form-control">
              <span
                :class="`${!!sale.is_upsell ? 'active' : 'inactive'}-badge`"
              >
                {{ !!sale.is_upsell ? "Sim" : "Não" }}
              </span>
            </div>
          </div>
        </div>
      </b-tab>

      <b-tab title="Tarifas e comissões">
        <div class="row mt-5">
          <div class="col-lg-6">
            <small>Valor pago pelo comprador</small>
            <div class="form-control">
              R$
              {{ sale.is_trial ? "0,00" : formatMoney(sale.original_amount) }}
            </div>
          </div>
          <div class="col-lg-6">
            <small>Sua comissão</small>
            <div class="form-control">R$ {{ formatMoney(sale.amount) }}</div>
          </div>
          <div class="col-lg-6">
            <small>Tarifa {{ $config.get("title") }}</small>
            <div class="form-control">
              R$ {{ formatMoney(sale.velora_amount) }}
            </div>
          </div>
          <div class="col-lg-6">
            <small>Outras comissões</small>
            <div class="form-control">
              R$ {{ formatMoney(sale.partners_amount) }}
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>

    <modal-completed
      v-model="completed.modal"
      title="Concluído"
      :description="completed.text"
    />

    <responsive-modal v-model="changeEmailDialog" size="lg">
      <change-email :id="sale.id" @close="changeEmailDialog = false" />
    </responsive-modal>
  </div>
</template>

<script>
import ChangeEmail from "./ChangeEmail";

import SaleMixin from "@/mixins/sale";

import { formatMoney } from "@/functions/helpers";
import { first, get } from "lodash";
import { mapState } from "vuex";

const formatDate = dateStr => {
  if (!dateStr) {
    return "-";
  }
  let arr = dateStr.split("T");
  if (arr.length < 2) {
    return "-";
  }
  return (
    arr[0]
      .split("-")
      .reverse()
      .join("/") +
    " às " +
    arr[1].substr(0, 5)
  );
};

export default {
  components: { ChangeEmail },
  mixins: [SaleMixin],
  data() {
    return {
      loadingCard: false,
      loadingPost: false,
      changeEmailDialog: false
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("sale", ["sale"]),
    saleProduct() {
      return this.products.find(p => p.id === this.sale?.product);
    },
    lastCard() {
      return first(get(this.sale, "charge_data.cards", []));
    },
    showChangeCard() {
      return (
        this.sale.charge_type === "recurrent" ||
        this.sale.charge_type === "signature"
      );
    },
    code() {
      return this.sale && this.sale.shopper_code
        ? this.sale.shopper_code.slice(0, 8).toUpperCase()
        : "";
    },
    createdAt() {
      return formatDate(this.sale.created_at);
    },
    paidAt() {
      return this.sale.status === "failed"
        ? "-"
        : formatDate(this.sale.paid_at);
    }
  },
  methods: {
    formatMoney,
    copyLink() {
      let link = this.sale.shopper_offer_link;
      if (link) {
        navigator.clipboard.writeText(link);
        this.$message.success("Link copiado");
      }
    },
    copyChangeLink() {
      let link = this.sale.token_subscription.link;
      if (link) {
        navigator.clipboard.writeText(link);
        this.$message.success("Link copiado");
      }
    },
    changeCard() {
      this.loadingCard = true;
      this.$store
        .dispatch("subscriptions/requestChangeCard", this.sale.id)
        .then(() => {
          this.$message.success(
            "Um e-mail foi enviado ao cliente com um link para alterar os dados do cartão"
          );
        })
        .catch(() => {
          this.$message.error("Erro");
        })
        .finally(() => {
          this.loadingCard = false;
        });
    },
    resendPost() {
      this.loadingPost = true;
      window.axios
        .post(`/scrambled/order/resend-event/${this.sale.id}`)
        .then(() => {
          this.$message.success("Evento reenviado com sucesso");
        })
        .catch(error => {
          this.$message.error(
            get(error, "response.data.message", "Erro ao reenviar evento")
          );
        })
        .finally(() => {
          this.loadingPost = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.sale-details {
  small {
    color: var(--l-neutral-45, rgba(87, 88, 107, 0.88));
  }
  .form-control {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    min-height: 40px;
    margin: 4px 0 8px;
    border-radius: 4px;
    background: rgba(219, 221, 230, 0.2);
    color: var(--l-neutral-45, rgba(87, 88, 107, 0.88));
    border: 1px solid var(--l-neutral-2, rgba(155, 157, 176, 0.86));

    .ellipsis {
      display: block;
      overflow-x: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  @media screen and (min-width: 992px) {
    .row {
      padding: 0 12px;
      .col-lg-6 {
        padding: 0 4px !important;
      }
    }
  }
  ::v-deep {
    .nav-tabs {
      border-color: transparent;
    }
    .nav-item {
      a {
        &.active,
        &:hover {
          font-size: 14px;
        }
      }
    }
  }
  .btn-outline-primary:not(:hover, :active) {
    background-color: #9955ff14;
  }
}
</style>
